<h3 class="row">
    <span class="item">
        <span>Observance</span>
    </span>
    <span class="item">
        <span>IAHR</span>
    </span>
</h3>
<tui-axes class="axes" [horizontalLines]="12" [axisYLabels]="['0', '', '', '', '', '5', '', '', '', '', '10', '', '']">
    <tui-bar-chart [max]="12" [value]="[obsList]" [tuiHintContent]="hint" />
    <tui-line-chart class="chart" [dots]="true" [smoothingFactor]="70" [height]="12" [width]="iahrList.length"
        [x]="-0.5" [value]="iahrList | coordonneesGraphique" />
</tui-axes>

<ng-template #hint let-data>
    <app-telesuivi-graphique-hint-observance-et-iahr [index]="data" [obsList]="obsList" [iahrList]="iahrList"
        [dateList]="dateList" />
</ng-template>